"use client";
import React, { useRef } from "react";
import style from "./HeroAbout.module.scss";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";
import { useRefStore } from "../../../store/ref-store";
import AboutDucks from "./AboutDucks";

const HeroAbout = ({ messages }) => {
  const heroRef = useRef(null);
  const { websiteLoading } = useRefStore();
  const titleRef = useRef(null);

  useGSAP(
    () => {
      if (!websiteLoading) {
        let isSingleLine = false;

        if (typeof window !== undefined) {
          isSingleLine = window.innerWidth === 1000;
        }
        gsap.fromTo(
          [".title", ".titleMiddle", ".title-outline"],
          {
            x: gsap.utils.wrap(["-50%", "50%", "-50%"]),
            opacity: 0,
          },
          {
            x: "0%",
            opacity: 1,
            duration: 1,
            ease: "power4.out",
            delay: 0.5,
          }
        );
        gsap.fromTo(
          ".paragraph",
          {
            opacity: 0,
          },
          {
            opacity: 1,
            duration: 2,
            ease: "power4.out",
            delay: 0.5,
          }
        );
      }
    },
    { scope: heroRef, dependencies: [websiteLoading] }
  );

  return (
    <section className={style.sectionContainer}>
      <div className="container" ref={heroRef}>
        <div className={style.textContainer}>
          <h1 className="title-section" ref={titleRef}>
            <span className="title">{messages.first_words} </span>
            <span className="titleMiddle">{messages.second_words} </span>
            <span className={`title-outline`}>{messages.last_word}</span>
          </h1>
          <p className="paragraph">{messages.description}</p>
        </div>
      </div>
      <AboutDucks trigger={style.sectionContainer} />
    </section>
  );
};

export default HeroAbout;

HeroAbout.displayName = "HeroAbout";
